<script setup>
import { ref } from "vue";
import MainEditor from "./components/MainEditor.vue";
import CardEdit from "./components/CardEdit.vue";
import Register from "./components/Register.vue";
import Help from "./components/Help.vue";
import UIDesign from "./components/UIDesign.vue";

import { useAppLogic } from "./composables/useAppLogic.js";
import { noWindow } from "./utils/windows.js";

const {
  storyData,
  uploadedData,
  importActions,
  edit,
  session,
  apiUrl,
  backend,
  shareMode,
  features,
  dragging,
  saveData,
  downloadData,
  uploadData,
  cancelImport,
  debugInfo,
  linesRefresh,
  scaleView,
  editCard,
  scrollToCard,
  editPreviousCard,
  cardClipboard,
  deleteSelectedCards,
  copySelectedCards,
  cutSelectedCards,
  pasteCards,
  setStoryData,
  setDropTarget,
  addTextKey,
  addLink,
  nodeOutDown,
  draggingCard,
  cardDown,
  cardUp,
  setCurrentStory,
  setLanguage,
  deleteLanguage,
  addLanguage,
  over,
  focusParagraph,
  deleteCard,
} = useAppLogic();

function followLinkToCard(id) {
  editCard(id);
  scrollToCard(id);
}

function previewFocusCard({ story, card }) {
  edit.currentStorylet = story;
  editCard(card);
  setTimeout(() => {
    scrollToCard(card);
    linesRefresh();
  }, 0);
}

const mainEditorRef = ref(null);

function previewCurrentCard() {
  mainEditorRef.value?.previewCurrentCard();
}
</script>

<template>
  <div>
    <MainEditor v-if="session.user" ref="mainEditorRef" :storyData="storyData.data" :edit="edit" :session="session" :apiUrl="apiUrl" :backend="backend"
      :shareMode="shareMode" :features="features"
      :uploadedData="uploadedData" :importActions="importActions" :dragging="dragging"
      :cardClipboard="cardClipboard"
      @set-story="setStoryData" @download-data="downloadData" @upload-data="uploadData" @cancel-import="cancelImport"
      @save-data="saveData" @set-current-story="setCurrentStory" @delete-language="deleteLanguage"
      @add-language="addLanguage" @set-language="setLanguage" @over="over" @card-down="cardDown" @card-up="cardUp"
      @edit-card="editCard" @delete-card="deleteCard" @edit-previous-card="editPreviousCard"
      @drop-target="setDropTarget" @node-out-down="nodeOutDown" @link-add="addLink"
      @debug-info="debugInfo" @scale-view="scaleView"
      @dragging-card="draggingCard" @lines-refresh="linesRefresh"
      @delete-selected="deleteSelectedCards" @cut-selected="cutSelectedCards"
      @copy-selected="copySelectedCards" @paste-cards="pasteCards"
      @focus-card="previewFocusCard" />

    <CardEdit :editingCard="edit.editingCard" :storyData="storyData.data" :edit="edit" @focus-paragraph="focusParagraph"
      @edit-card="editCard" @follow-link="followLinkToCard" @edit-previous-card="editPreviousCard" @text-key="addTextKey" @lines-refresh="linesRefresh"
      @link-add="addLink" @preview-card="previewCurrentCard" />
    <Help v-if="edit.helpWindow" @close-win="noWindow(edit)" />
    <div class="share-mode-signin" v-if="shareMode && !session.user">
      <p>Your session couldn't be verified. Please return to tvain-share and log in again.</p>
      <a href="/login">Back to tvain-share login</a>
    </div>
    <Register :apiUrl="apiUrl" :backend="backend" v-else-if="!session.user" />

    <UIDesign v-if="1 == 2" />
  </div>

  <div style="position: absolute; left: -320px; top: 20px">
    <input type="file" id="fileInput" accept=".json" />
  </div>
</template>
